import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "panel-row" }
const _hoisted_2 = { class: "pool-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericSubPanel = _resolveComponent("GenericSubPanel")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "pool-container",
    "center-y": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_GenericSubPanel, { class: "sub-panel" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["panel-title pool-title", _ctx.successClass]),
              onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInfo('SPECIAL', 'PL')))
            }, " SPECIAL POINTS ", 34),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state.build.SPECIAL.PL.value), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}